import { Component, Injector, OnInit } from '@angular/core';
import { EventService } from '../../core/services/event.service';

import { LAYOUT_WIDTH, SIDEBAR_TYPE, TOPBAR, LAYOUT_MODE } from '../layouts.model';
import { SidebarService } from 'src/app/core/services/sidebar.service';

@Component({
  selector: 'app-rightsidebar',
  templateUrl: './rightsidebar.component.html',
  styleUrls: ['./rightsidebar.component.scss']
})

/**
 * Rightsidebar component
 */
export class RightsidebarComponent implements OnInit {

  content: any = null;
  contentInputs: any = {};

  constructor(private sidebarService: SidebarService) {}
  ngOnInit() {
    this.sidebarService.content$.subscribe((content) => {
      this.content = content;
    });
    this.sidebarService.contentInputs$.subscribe((inputs) => {
      this.contentInputs = inputs;
    });
  }
  onOverlayClick() {
    document.body.classList.remove('right-bar-enabled');
    this.sidebarService.setContent(null, {});
  }

}
